var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonalSetting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 207.342,
    height: 176.911,
    viewBox: "0 0 207.342 176.911",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "personal_setting",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M574.943,645.462a7.42,7.42,0,0,0,7.165-1.262c2.509-2.106,3.3-5.576,3.936-8.789l1.894-9.5-3.964,2.73c-2.851,1.963-5.766,3.989-7.74,6.833s-2.835,6.725-1.25,9.8",
    transform: "translate(-478.407 -483.55)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M576.953,675.976a47.674,47.674,0,0,1-.661-10.992,17.291,17.291,0,0,1,3.333-9.064,15.08,15.08,0,0,1,3.869-3.505c.387-.244.743.369.358.612a14.335,14.335,0,0,0-5.67,6.841,22.976,22.976,0,0,0-1.22,9.9c.129,2.017.4,4.021.676,6.022a.367.367,0,0,1-.248.436.356.356,0,0,1-.436-.248Z",
    transform: "translate(-479.805 -501.896)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M590.433,697.014a5.462,5.462,0,0,0,4.759,2.457c2.41-.114,4.418-1.8,6.226-3.392l5.348-4.722-3.539-.169a21.234,21.234,0,0,0-7.58.549c-2.424.786-4.66,2.674-5.1,5.183",
    transform: "translate(-489.693 -528.767)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M574,711.425c2.4-4.25,5.188-8.974,10.167-10.484a11.346,11.346,0,0,1,4.276-.442c.454.039.341.739-.112.7A10.539,10.539,0,0,0,581.51,703a17.737,17.737,0,0,0-4.691,5.062c-.777,1.183-1.473,2.416-2.168,3.647C574.429,712.107,573.779,711.823,574,711.425Z",
    transform: "translate(-478.266 -535.255)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M437.146,285.975H261.671V161.326H437.146Z",
    transform: "translate(-261.671 -161.326)",
    fill: "#f5f9fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M304.449,328.4a1.71,1.71,0,1,0,0,3.419h59.258a1.71,1.71,0,1,0,0-3.419Z",
    transform: "translate(-290.155 -277.207)",
    fill: "#26ad8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M304.441,361.881a1.71,1.71,0,0,0-.007,3.42h59.309a1.71,1.71,0,1,0,0-3.42Z",
    transform: "translate(-290.147 -300.427)",
    fill: "#26ad8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M304.441,394.881a1.71,1.71,0,1,0-.007,3.419H317.78a1.71,1.71,0,0,0,0-3.419Z",
    transform: "translate(-290.147 -323.315)",
    fill: "#26ad8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M437.146,285.975H261.671V161.326H437.146Zm-172.591-2.885H434.262V164.211H264.555Z",
    transform: "translate(-261.671 -161.326)",
    fill: "#d3ddde"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M647.167,478.732a3.076,3.076,0,0,0-.013,6.151h29.367a3.076,3.076,0,0,0,0-6.151Z",
    transform: "translate(-526.905 -381.472)",
    fill: "#d3ddde"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M647.167,357.185a3.076,3.076,0,0,0-.013,6.151h29.367a3.076,3.076,0,0,0,0-6.151Z",
    transform: "translate(-526.905 -297.17)",
    fill: "#d3ddde"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M304.441,483.381a1.71,1.71,0,1,0-.007,3.419h59.309a1.71,1.71,0,1,0,0-3.419Z",
    transform: "translate(-290.147 -384.697)",
    fill: "#d3ddde"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M304.441,516.381a1.71,1.71,0,1,0-.007,3.419H317.78a1.71,1.71,0,0,0,0-3.419Z",
    transform: "translate(-290.147 -407.585)",
    fill: "#d3ddde"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M304.449,449.9a1.71,1.71,0,1,0,0,3.42h59.258a1.71,1.71,0,0,0,0-3.42Z",
    transform: "translate(-290.155 -361.476)",
    fill: "#d3ddde"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M304.449,206.9a1.71,1.71,0,1,0,0,3.42h59.258a1.71,1.71,0,1,0,0-3.42Z",
    transform: "translate(-290.155 -192.937)",
    fill: "#d3ddde"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M304.441,240.381a1.71,1.71,0,0,0-.007,3.42h59.309a1.71,1.71,0,1,0,0-3.42Z",
    transform: "translate(-290.147 -216.157)",
    fill: "#d3ddde"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M304.441,273.381a1.71,1.71,0,0,0-.007,3.42H317.78a1.71,1.71,0,0,0,0-3.42Z",
    transform: "translate(-290.147 -239.045)",
    fill: "#d3ddde"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M647.167,235.732a3.076,3.076,0,0,0-.013,6.151h29.367a3.076,3.076,0,0,0,0-6.151Z",
    transform: "translate(-526.905 -212.933)",
    fill: "#d3ddde"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 5.516,
    cy: 5.516,
    r: 5.516,
    transform: "translate(120.933 20.33)",
    fill: "#bbc4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M705.728,365.523A3.057,3.057,0,0,0,708.877,369l2.929,6.343,4.289-.84-4.262-8.9a3.074,3.074,0,0,0-6.1-.077Z",
    transform: "translate(-569.64 -301.099)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M481.475,242.809l-11.95-5.911-8.433-14.312-5.894,2.851,7.649,16.534,19.324,11.155Z",
    transform: "translate(-315.716 -154.381)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M440.358,540.179H436.6l-1.787-10.831h5.545Z",
    transform: "translate(-301.578 -367.144)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M690.286,726.887H678.173v-.153a4.715,4.715,0,0,1,4.714-4.715h7.4Z",
    transform: "translate(-550.548 -550.211)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M548.963,525.1l-2.621,2.691-9.006-6.277,3.868-3.972Z",
    transform: "translate(-372.685 -358.959)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M825.044,701.9l-8.452,8.677-.11-.107a4.715,4.715,0,0,1-.088-6.667h0l5.162-5.3Z",
    transform: "translate(-645.488 -533.901)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M682.549,515.652h-2.6A72.593,72.593,0,0,0,664.807,541.2l-3.1,9.088,11.063,23.162,6.9.123-7.89-24.591,7.949-10.541.4,21.19,25.584,13.41,5.12-7.564-20.818-11.384,3.545-18.024a12.989,12.989,0,0,0,2.979-15.247Z",
    transform: "translate(-539.125 -407.079)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M758.049,427.971l-10.8-4.729-11.884,5.266s-3.365,1.914-1.22,6.817l-12.894,16.234,16.228,5.169,14.62-12.875a18,18,0,0,0,5.947-15.882Z",
    transform: "translate(-580.429 -342.986)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 7.526,
    cy: 7.526,
    r: 7.526,
    transform: "translate(168.283 65.065)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M827.767,362.843a5.2,5.2,0,0,0-6.189-.378,7.956,7.956,0,0,0-9.542,1.933,3.842,3.842,0,0,0-.974,3.5c.4,1.2,2.109,1.905,3,1.01l-.016.369a5.974,5.974,0,0,1-3.714,10.173l7.4,2.989a8.668,8.668,0,0,0,3.228.839,2.95,2.95,0,0,0,2.746-1.581l.937,2.871a47.253,47.253,0,0,0,4.509-9.3,17.721,17.721,0,0,0,1.27-6.516A7.957,7.957,0,0,0,827.767,362.843Z",
    transform: "translate(-642.212 -300.24)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 5.516,
    cy: 5.516,
    r: 5.516,
    transform: "translate(120.933 94.79)",
    fill: "#bbc4c4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 5.516,
    cy: 5.516,
    r: 5.516,
    transform: "translate(138.092 57.575)",
    fill: "#26ad8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M730.728,355.523A3.057,3.057,0,0,0,733.877,359l2.929,6.343,4.289-.84-4.262-8.9a3.074,3.074,0,0,0-6.1-.077Z",
    transform: "translate(-586.979 -294.163)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M506.475,232.809l-11.95-5.911-8.433-14.312-5.894,2.851,7.649,16.534,19.324,11.155Z",
    transform: "translate(-333.055 -147.445)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M672.382,737.287H555.635a.306.306,0,1,1,0-.613H672.382a.306.306,0,1,1,0,.613Z",
    transform: "translate(-465.346 -560.376)",
    fill: "#cacaca"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalSetting);
export default __webpack_public_path__ + "static/media/personal_setting.07463d908acca002e4e35208194ee9f5.svg";
export { ForwardRef as ReactComponent };